import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  TablePagination,
  Dialog,
  IconButton,
  Typography,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import moment from "moment-timezone";

import { endPoints, paymentEndpoints } from "../../constant/Environment";
import { getAllData, getAllFilterData, postPaymentData } from "../../Utility/API";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import PageHeader from "../../components/PageHeader";
import SectionCard from "../../components/SectionCard";
import { tokens } from "../../theme";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import {
  mono,
  pill,
  statusKind,
  th,
  td,
  filterFieldSx,
  unsettledRowBg,
  FactRows,
  ConfirmDialog,
  TablePaginationActions,
} from "../../components/tableKit";

const fmtDate = (d) => (d && moment.utc(d).isValid() ? moment.utc(d).format("YYYY-MM-DD") : "");

// Attention tints carried over from the legacy screen's deposit-source rules.
const rowBg = (row) => {
  if (
    (!row.payWithBet && row.depositSource === "Same") ||
    (row.payWithBet && row.depositSource === "Different")
  )
    return "rgba(245,166,35,0.12)";
  if (!row.payWithBet && row.depositSource === "Different") return unsettledRowBg;
  return undefined;
};

const Withdrawals = () => {
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalcount, setTotalCount] = useState(0);

  const [userId, setUserId] = useState("");
  const [name, setName] = useState("");
  const [username, setuserName] = useState("");
  const [Transtype, setTransType] = useState("");

  const [editData, setEditData] = useState({});
  const [transData, setTransData] = useState([]);
  const [viewShow, setViewShow] = useState(false);
  const [checkShow, setCheckShow] = useState(false);
  const [pauseShow, setPauseShow] = useState(false);
  const [cancleShow, setCancleShow] = useState(false);

  const [verifyShow, setVerifyShow] = useState(false);
  const [verifyRecord, setVerifyRecord] = useState({});
  const [verificationCode, setVerificationCode] = useState("");

  let filteredData = {
    userId: userId,
    status: Transtype,
    name: name,
    userName: username,
  };

  useEffect(() => {
    paymentsData(1, filteredData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    paymentsData(page, filteredData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage]);

  // withdrawal payments get api call
  const paymentsData = async (page, data) => {
    let url = `${endPoints.api.WITHDRAW_TRANSACTIONS}/${page}/${rowsPerPage}`;
    setIsLoading(true);
    await getAllFilterData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setRows(response.data || []);
          setTotalCount(response.data?.[0]?.totalcount || 0);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const getTransactionDetails = async (custId) => {
    let url = `${endPoints.api.GET_TRANSACTION_DETAILS}/${custId}`;
    setIsLoading(true);
    await getAllData(url)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          setTransData(response.data || []);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const updateStatus = async (alldata, status, closeDialog, onSuccess) => {
    try {
      let url = `${endPoints.api.TRANSACTION_UPDATE}`;
      let data = {
        id_transaction: alldata.id_transaction,
        id_user: alldata.id_user,
        external_id: alldata.external_id,
        status: status,
      };
      setIsLoading(true);
      let response = await getAllFilterData(url, data);
      setIsLoading(false);
      if (response.status === "success") {
        SuccesToast(response.message);
        alldata.external_id = response.data?.external_id ?? alldata.external_id;
        paymentsData(page, filteredData);
        closeDialog();
        onSuccess?.(alldata);
      } else {
        ErrorToast(response.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const openVerification = (alldata) => {
    setVerifyRecord(alldata);
    setVerificationCode("");
    setVerifyShow(true);
  };

  const VerifyPayout = async () => {
    const code = verificationCode.trim();
    if (!code) {
      ErrorToast("Please enter the verification code");
      return;
    }
    try {
      let url = `${paymentEndpoints.api.PAYOUT_VERIFY}${verifyRecord.external_id}/verify`;
      setIsLoading(true);
      let response = await postPaymentData(url, { verification_code: Number(code) });
      setIsLoading(false);
      if (response?.status === "success") {
        SuccesToast(response.message);
        paymentsData(page, filteredData);
        setVerifyShow(false);
        setVerificationCode("");
      } else {
        ErrorToast(response?.message);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    paymentsData(newPage + 1, filteredData);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const confirmFacts = (d) => [
    ["Customer ID", d?.id_user],
    ["Transaction ID", d?.id_transaction],
    ["Customer Name", d?.name],
    ["Transaction Date", fmtDate(d?.insertion_time)],
    ["User Name", d?.login],
    ["Amount", d?.tamount != null ? `${d.tamount}` : "—"],
    ["Type", d?.wallet_type],
  ];

  const detailFacts = (d) => [
    ...confirmFacts(d),
    ["Withdrawal Status", d?.transaction_status],
    ["Status Updated", fmtDate(d?.updated_on)],
    ["Updated By", d?.adminname],
    ["Account Status", d?.accountSatus],
    ["Rational", d?.reason],
  ];

  return (
    <Box>
      <Toaster></Toaster>
      {isLoading && <Loader spinner={true} visible={isLoading} />}

      <PageHeader
        title="Withdrawals"
        crumb="Finance / Withdrawals"
        subtitle="Player withdrawal requests · review, approve or hold"
      />

      <SectionCard>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5, alignItems: "center", mb: 2 }}>
          <TextField
            size="small"
            label="Customer ID"
            placeholder="Enter Customer ID"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            sx={filterFieldSx}
          />
          <TextField
            size="small"
            label="Name"
            placeholder="Enter First or Last Name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            sx={filterFieldSx}
          />
          <TextField
            size="small"
            label="Username"
            placeholder="Enter Username"
            value={username}
            onChange={(e) => setuserName(e.target.value)}
            sx={filterFieldSx}
          />
          <TextField
            select
            size="small"
            label="Withdrawal Status"
            value={Transtype}
            onChange={(e) => setTransType(e.target.value)}
            sx={{ ...filterFieldSx, minWidth: 170 }}
          >
            <MenuItem value="">All</MenuItem>
            <MenuItem value="1">Approved</MenuItem>
            <MenuItem value="0">Pending</MenuItem>
            <MenuItem value="2">Hold</MenuItem>
            <MenuItem value="3">Cancelled</MenuItem>
          </TextField>
          <Button
            variant="contained"
            size="small"
            onClick={() => {
              setPage(1);
              paymentsData(1, filteredData);
            }}
            sx={{ textTransform: "none" }}
          >
            Search
          </Button>
        </Box>

        <Box sx={{ overflowX: "auto" }}>
          <Box component="table" sx={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={th}>Player</th>
                <th style={th}>Transaction ID</th>
                <th style={th}>External ID</th>
                <th style={th}>Trans Date</th>
                <th style={{ ...th, textAlign: "right" }}>Amount</th>
                <th style={th}>Status</th>
                <th style={th}>VIP</th>
                <th style={th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 && !isLoading && (
                <tr>
                  <td colSpan={7} style={{ ...td, textAlign: "center", color: tokens.textDim }}>
                    No withdrawal requests found
                  </td>
                </tr>
              )}
              {rows.map((row) => (
                <tr key={row.id_transaction} style={{ background: rowBg(row) }}>
                  <td style={td}>
                    <div style={{ fontWeight: 600 }}>{row.login}</div>
                    <div style={{ fontFamily: mono, fontSize: 10.5, color: tokens.textDim2 }}>
                      #{row.id_user} · {row.name} {row.surname}
                    </div>
                  </td>
                  <td style={{ ...td, fontFamily: mono }}>{row.id_transaction}</td>
                  <td style={{ ...td, fontFamily: mono }}>{row.external_id}</td>
                  <td style={{ ...td, fontFamily: mono }}>{fmtDate(row.insertion_time)}</td>
                  <td style={{ ...td, fontFamily: mono, fontWeight: 700, textAlign: "right" }}>
                    {row.tamount}
                  </td>
                  <td style={td}>{pill(row.transaction_status, statusKind(row.transaction_status))}</td>
                  <td style={td}>{row.VIP}</td>
                  <td style={td}>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        size="small"
                        variant="outlined"
                        color="inherit"
                        sx={{ textTransform: "none", color: tokens.textDim, borderColor: tokens.border }}
                        onClick={() => {
                          setViewShow(true);
                          setEditData(row);
                          getTransactionDetails(row.id_user);
                        }}
                      >
                        View
                      </Button>
                      {row.ext_status == "Pending" && (
                        <Button
                          size="small"
                          variant="outlined"
                          disabled={!row.external_id}
                          sx={{ textTransform: "none", color: tokens.secondary, borderColor: "rgba(35,214,160,0.4)" }}
                          onClick={() => openVerification(row)}
                        >
                          Verify
                        </Button>
                      )}
                      {row.status == 1 || row.status == 3 ? null : (
                        <>
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ textTransform: "none", color: tokens.secondary, borderColor: "rgba(35,214,160,0.4)" }}
                            onClick={() => {
                              setCheckShow(true);
                              setEditData(row);
                            }}
                          >
                            Approve
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            disabled={row.status == 2}
                            sx={{ textTransform: "none", color: tokens.amber, borderColor: "rgba(245,166,35,0.4)" }}
                            onClick={() => {
                              setPauseShow(true);
                              setEditData(row);
                            }}
                          >
                            Hold
                          </Button>
                          <Button
                            size="small"
                            variant="outlined"
                            sx={{ textTransform: "none", color: tokens.danger, borderColor: "rgba(242,92,102,0.4)" }}
                            onClick={() => {
                              setCancleShow(true);
                              setEditData(row);
                            }}
                          >
                            Cancel
                          </Button>
                        </>
                      )}
                    </Box>
                  </td>
                </tr>
              ))}
            </tbody>
          </Box>
        </Box>

        <TablePagination
          component="div"
          rowsPerPageOptions={[5, 10, 25, 50]}
          count={rowsPerPage === -1 ? rows.length : Number(totalcount) || 0}
          rowsPerPage={rowsPerPage}
          page={page - 1}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </SectionCard>

      {/* Approve */}
      <ConfirmDialog
        open={checkShow}
        onClose={() => setCheckShow(false)}
        title="Withdrawal Approval"
        facts={confirmFacts(editData)}
        question="Would you like to Approve this transaction?"
        note="After approval, funds will be sent to the payment provider."
        actionLabel="Approve Withdrawal"
        actionColor={tokens.secondary}
        onAction={() => updateStatus(editData, 1, () => setCheckShow(false), openVerification)}
      />

      {/* Payout verification code */}
      <ConfirmDialog
        open={verifyShow}
        onClose={() => setVerifyShow(false)}
        title="Payout Verification"
        facts={[...confirmFacts(verifyRecord), ["Payout ID", verifyRecord?.external_id]]}
        question="Enter the verification code to release this payout."
        note="A verification code was sent for this payout. The payout is only released once the code is verified."
        actionLabel="Verify Payout"
        actionColor={tokens.secondary}
        actionDisabled={!verificationCode.trim()}
        onAction={VerifyPayout}
      >
        <TextField
          size="small"
          fullWidth
          autoFocus
          label="Verification Code"
          placeholder="Enter verification code"
          value={verificationCode}
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, ""))}
          onKeyDown={(e) => {
            if (e.key === "Enter") VerifyPayout();
          }}
          sx={{ mt: 1.5 }}
        />
      </ConfirmDialog>

      {/* Hold */}
      <ConfirmDialog
        open={pauseShow}
        onClose={() => setPauseShow(false)}
        title="Place Withdrawal On Hold"
        facts={confirmFacts(editData)}
        question="Would you like to put this transaction on Hold?"
        note="This transaction will be held while you investigate. You can return later to approve or cancel."
        actionLabel="Put Withdrawal on Hold"
        actionColor={tokens.amber}
        onAction={() => updateStatus(editData, 2, () => setPauseShow(false))}
      />

      {/* Cancel */}
      <ConfirmDialog
        open={cancleShow}
        onClose={() => setCancleShow(false)}
        title="Withdrawal Cancellation"
        facts={confirmFacts(editData)}
        question="Would you like to Cancel this transaction?"
        note="After cancellation funds will be returned to the player's account."
        actionLabel="Cancel Withdrawal"
        actionColor={tokens.danger}
        onAction={() => updateStatus(editData, 3, () => setCancleShow(false))}
      />

      {/* View details */}
      <Dialog
        open={viewShow}
        onClose={() => setViewShow(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{ sx: { background: tokens.cardBg, border: `1px solid ${tokens.border}`, borderRadius: "12px" } }}
      >
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", px: 2.5, py: 1.5, borderBottom: `1px solid ${tokens.border}` }}>
          <Typography variant="h6" sx={{ fontSize: 16 }}>Withdrawal Details</Typography>
          <IconButton size="small" onClick={() => setViewShow(false)} aria-label="close">
            <CloseRoundedIcon fontSize="small" />
          </IconButton>
        </Box>
        <Box sx={{ p: 2.5 }}>
          <FactRows facts={detailFacts(editData)} />

          <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2.5 }}>
            <Button
              size="small"
              variant="outlined"
              color="inherit"
              onClick={() => setViewShow(false)}
              sx={{ textTransform: "none", color: tokens.textDim, borderColor: tokens.border }}
            >
              Close
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default Withdrawals;
